import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-card-variant',
  templateUrl: './card-variant.component.html',
  styleUrls: ['./card-variant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardVariantComponent {
}
